if (!customElements.get('workspace-product-fact')) {
  customElements.define('workspace-product-fact', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source !== 'variant') return;
      this.optionUnsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.closest('product-info')?.contains(data.event.target)) this.hidden = true;
      });
      this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const next = data.html.getElementById(this.id);
        const wasOpen = this.querySelector('details')?.open;
        if (!next) {
          this.hidden = true;
          return;
        }
        this.replaceChildren(...Array.from(next.childNodes).map(node => node.cloneNode(true)));
        this.hidden = next.hidden;
        if (wasOpen && this.querySelector('details')) this.querySelector('details').open = true;
      });
    }
    disconnectedCallback() {
      this.optionUnsubscribe?.();
      this.variantUnsubscribe?.();
    }
  });
}
